module.exports = __webpack_public_path__ + "static/media/flash2.6877b8a5.svg";